import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@store/auth';
import { completeMcpHandoff, stashMcpParamsIfPresent } from './mcp-handoff';

/**
 * MCP bağlantı köprüsü — `/baglan`.
 *
 * Claude connector "Connect" dediğinde MCP, /authorize → buraya yönlendirir:
 *   app.zoprey.com/baglan?mcp_redirect=<MCP callback>&ar=<auth request>
 *
 * Auth durumundan BAĞIMSIZ (PublicOnlyRoute/ProtectedRoute dışında):
 *  - Kullanıcı zaten girişliyse → handoff'u hemen tamamla (MCP'ye dön).
 *  - Girişli değilse → parametreleri sakla, /auth/login'e gönder; giriş sonrası
 *    LoginPage (veya Google AuthCallback) handoff'u tamamlar.
 *
 * Bu sayfa, "zaten girişliyken consent gelmiyor" sorununu çözer.
 */
export function ConnectMcpPage() {
  const navigate = useNavigate();
  const session = useAuthStore((s) => s.session);
  const loading = useAuthStore((s) => s.loading);
  const ran = useRef(false);

  useEffect(() => {
    if (loading || ran.current) return;
    ran.current = true;

    (async () => {
      if (session) {
        // Zaten girişli → handoff'u doğrudan tamamla (consent MCP tarafında çıkar).
        const ok = await completeMcpHandoff();
        if (!ok) navigate('/dashboard', { replace: true });
      } else {
        // Girişsiz → parametreleri sakla, login'e gönder.
        stashMcpParamsIfPresent();
        navigate('/auth/login', { replace: true });
      }
    })();
  }, [loading, session, navigate]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 text-muted-foreground">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-current border-t-transparent" />
      <p className="text-sm">Zoprey'e bağlanılıyor…</p>
    </div>
  );
}
